import { type ITicketSuggestion } from '../models/ticket-suggestion.model';
import { TimeLimitation } from '../models/time-limitation.enum';
import { Channel } from '../models/channel.enum';

export class TicketSuggestionHelper {
  public static validSalesChannels = [Channel.toGo, Channel.ombud, Channel.ombord, Channel.tapAndGo];

  public static hasValidSalesChannelsAndTimeLimitation(ticketSuggestion: ITicketSuggestion): boolean {
    const hasValidSalesChannel = ticketSuggestion.saleChannels.some((x) => this.validSalesChannels.indexOf(x.id) > -1);
    return !(!hasValidSalesChannel || ticketSuggestion.timeLimitation !== TimeLimitation.heltid);
  }
}
